export const GetRollingBearingFailureBearings = "GetRollingBearingFailureBearings";
export const GetRollingBearingFailureBearingsError = "GetRollingBearingFailureBearingsError";
export const GetRollingBearingFailureBearingsSuccess = "GetRollingBearingFailureBearingsSuccess";
export const GetRollingBearingFailureResult = "GetRollingBearingFailureResult";
export const GetRollingBearingFailureResultError = "GetRollingBearingFailureResultError";
export const GetRollingBearingFailureResultSuccess = "GetRollingBearingFailureResultSuccess";
export const CREATE_SHAPES = "CREATE_SHAPES";
export const CREATE_ANNOTATIONS = "CREATE_ANNOTATIONS";
export const SHOW_BPFI = "SHOW_BPFI";
export const SHOW_BPFO = "SHOW_BPFO";
export const SHOW_BSF = "SHOW_BSF";
export const SHOW_FTF = "SHOW_FTF";
export const HIDE_BPFI = "HIDE_BPFI";
export const HIDE_BPFO = "HIDE_BPFO";
export const HIDE_BSF = "HIDE_BSF";
export const HIDE_FTF = "HIDE_FTF";
